import type { FC } from 'react';

import RichText from '@eneco/components/RichText/RichText';
import { NotificationBar } from '@eneco/sparky';
import { NotificationsBarRendering } from '@sitecore/types/NotificationsBar';

const NotificationsBar: FC<NotificationsBarRendering> = ({ fields: { notification, showNotificationOption } }) => {
  if (!showNotificationOption.value) return null;

  return (
    <NotificationBar
      title={notification.value.title}
      text={<RichText html={notification.value.content} />}
      variant={notification.value.variant || 'warning'}
    />
  );
};

export { NotificationsBar };
export default NotificationsBar;
